(function () {
	'use strict';

	var API_KEY = 'ZNGb5bsXKa9xvPe9x2qKDSnAxljcbLNe9t8alKVxFqk';

	function initAllMaps() {
		if (typeof L === 'undefined') {
			return;
		}

		var wrappers = document.querySelectorAll('.smap-wrapper');

		wrappers.forEach(function (wrapper) {
			var mapEl = wrapper.querySelector('.smap');
			if (!mapEl) return;

			// Only init if visible
			if (!(mapEl.offsetWidth || mapEl.offsetHeight || mapEl.getClientRects().length)) return;

			var markersData = [];
			var markersAttr = mapEl.getAttribute('data-markers');
			if (markersAttr) {
				try {
					var parsed = JSON.parse(markersAttr);
					if (Array.isArray(parsed)) markersData = parsed;
				} catch (e) {
					console.error('maps.js: Invalid data-markers JSON', e);
				}
			}

			initMap(wrapper, mapEl, markersData);
		});
	}

	function initMap(wrapper, mapEl, markersData) {
		var map = L.map(mapEl, {
			center: [49.8, 15.5],
			zoom: 8,
			zoomControl: false
		});

		// Store instance for external access
		mapEl._leaflet_map_instance = map;

		L.control.zoom({ position: 'topright' }).addTo(map);

		L.tileLayer('https://api.mapy.cz/v1/maptiles/basic/256/{z}/{x}/{y}?apikey=' + API_KEY, {
			attribution: '<a href="https://api.mapy.com/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
			maxZoom: 18,
			tileSize: 256
		}).addTo(map);

		// Required Mapy.cz logo
		var logoControl = L.control({ position: 'bottomleft' });
		logoControl.onAdd = function () {
			var container = L.DomUtil.create('div', 'mapycz-logo-control');
			container.innerHTML = '<a href="https://mapy.cz" target="_blank" rel="noopener"><img src="https://api.mapy.cz/img/api/logo.svg" alt="Mapy.cz" width="102" height="32"></a>';
			L.DomEvent.disableClickPropagation(container);
			return container;
		};
		logoControl.addTo(map);

		if (!markersData || markersData.length === 0) return;

		var positions = [];

		markersData.forEach(function (markerData) {
			var lat = parseFloat(markerData.latitude);
			var lng = parseFloat(markerData.longitude);
			if (isNaN(lat) || isNaN(lng)) return;

			var position = L.latLng(lat, lng);
			positions.push(position);

			var iconUrl = markerData.img || 'static/images/marker.svg';
			var icon = L.icon({
				iconUrl: iconUrl,
				iconSize: [40, 40],
				iconAnchor: [20, 40],
				popupAnchor: [0, -40]
			});

			var marker = L.marker(position, {
				icon: icon,
				title: markerData.title || ''
			});
			
			var popupHtml = '<div class="clearfix"' + (markerData.id ? ' id="marker-' + markerData.id + '"' : '') + '>';
			//if (markerData.previewImage) {
			//	popupHtml += '<div class="img"><img src="' + markerData.previewImage + '" alt="' + (markerData.title || '') + '"></div>';
			//}
			popupHtml += '<div class="text">';
			if (markerData.title) {
				popupHtml += '<p class="title">' + markerData.title + '</p>';
			}
			popupHtml += '<ul>';
			if (markerData.ulice) popupHtml += '<li>' + markerData.ulice + '</li>';
			if (markerData.mesto) popupHtml += '<li>' + markerData.mesto + '</li>';
			if (markerData.telefon) popupHtml += '<li>' + markerData.telefon + '</li>';
			if (markerData.www) popupHtml += '<li><a href="' + markerData.www + '" target="_blank">' + markerData.www + '</a></li>';
			popupHtml += '</ul>';
			popupHtml += '</div>';
			popupHtml += '</div>';

			marker.bindPopup(popupHtml, {
				className: 'smap-popup',
				closeButton: true,
				maxWidth: 260
			});

			marker.addTo(map);
		});

		if (positions.length > 1) {
			map.fitBounds(L.latLngBounds(positions), { padding: [40, 40] });
		} else if (positions.length === 1) {
			map.setView(positions[0], 15);
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAllMaps);
	} else {
		initAllMaps();
	}

})();